import React, { useState, useRef, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import PackageCarousel from '../components/PackageCarusal';
import EnquiryFormModal from '../components/EnquiryFormModal';
import ChatBox from '../components/ChatBox';
import HapptClients from '../components/HappyClients';
import AnimatedStatsPage from '../components/AnimatedStatsPage';
import TravelByTheme from '../components/travelByTheme';
import video from "../videos/travel-video.mp4";
import { VolumeUp, VolumeOff, Pause, PlayArrow } from "@mui/icons-material";
import { useNavigate } from 'react-router-dom';

const Home = () => {
    const [openEnquiry, setOpenEnquiry] = useState(false);
    const videoRef = useRef(null);
    const [isMuted, setIsMuted] = useState(true);
    const [isPlaying, setIsPlaying] = useState(true);
    const navigate = useNavigate()

    // Typewriter Effect
    const fullTitle = "Welcome to Dream FLY Holiday";
    const [index, setIndex] = useState(0); // which character to show
    const [displayedTitle, setDisplayedTitle] = useState("");

    useEffect(() => {
        if (index < fullTitle.length) {
            const timeout = setTimeout(() => {
                setDisplayedTitle(fullTitle.slice(0, index + 1));
                setIndex(index + 1);
            }, 120); // speed: 120ms per letter

            return () => clearTimeout(timeout);
        }
    }, [index]);

    const toggleMute = () => {
        const video = videoRef.current;
        video.muted = !video.muted;
        setIsMuted(video.muted);
    };

    const togglePlay = () => {
        const video = videoRef.current;
        if (video.paused) {
            video.play();
            setIsPlaying(true);
        } else {
            video.pause();
            setIsPlaying(false);
        }
    };

    return (
        <>
            <div style={{ position: "relative", width: "100vw", height: "600px", overflow: "hidden" }}>
                {/* Background Video */}
                <video
                    ref={videoRef}
                    src={video}
                    autoPlay
                    loop
                    muted={isMuted}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                    }}
                />

                {/* Content Overlay */}
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "white",
                        textAlign: "center",
                        background: "rgba(0,0,0,0.3)",
                    }}
                >
                    <h1
                        style={{
                            fontSize: "3rem",
                            fontWeight: "bold",
                            marginBottom: "10px",
                            letterSpacing: "2px",
                            minHeight: "60px",
                        }}
                    >
                        {displayedTitle}
                        <span
                            style={{
                                color: "red",
                                animation: "blink 1s step-end infinite",
                            }}
                        >
                            |
                        </span>
                    </h1>

                    <p style={{ fontSize: "1.2rem", maxWidth: "600px", marginBottom: "20px" }}>
                        Discover amazing destinations and plan your perfect vacation today.
                    </p>

                    <Button
                        variant="contained"
                        color="error"
                        style={{ fontSize: "1rem", padding: "10px 30px", borderRadius: "30px" }}
                        onClick={() => navigate("/packages")}
                    >
                        Book Now
                    </Button>
                </div>

                {/* Floating Controls */}
                <div
                    style={{
                        position: "absolute",
                        bottom: "20px",
                        right: "20px",
                        display: "flex",
                        gap: "10px",
                    }}
                >
                    {/* Play/Pause Button */}
                    <button
                        onClick={togglePlay}
                        style={{
                            background: "rgba(0,0,0,0.5)",
                            border: "none",
                            borderRadius: "50%",
                            width: "50px",
                            height: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            color: "white",
                        }}
                    >
                        {isPlaying ? <Pause /> : <PlayArrow />}
                    </button>

                    {/* Mute/Unmute Button */}
                    {/* <button
                        onClick={toggleMute}
                        style={{
                            background: "rgba(0,0,0,0.5)",
                            border: "none",
                            borderRadius: "50%",
                            width: "50px",
                            height: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            color: "white",
                        }}
                    >
                        {isMuted ? <VolumeOff /> : <VolumeUp />}
                    </button> */}
                </div>
            </div>

            {/* Other Components */}
            <ChatBox />
            <Box sx={{ p: { xs: 2, sm: 6, md: 10, lg: 10 } }}>
                <PackageCarousel />
                <TravelByTheme />
                <AnimatedStatsPage />
                <HapptClients />
            </Box>

            <EnquiryFormModal open={openEnquiry} setOpen={setOpenEnquiry} page="Home" />
        </>
    );
};

// Add blinking cursor animation
const style = document.createElement('style');
style.innerHTML = `
@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}`;
document.head.appendChild(style);

export default Home;
